import { render, staticRenderFns } from "./CreditNoteList.vue?vue&type=template&id=4dbd48ba&"
import script from "./CreditNoteList.vue?vue&type=script&lang=js&"
export * from "./CreditNoteList.vue?vue&type=script&lang=js&"
import style0 from "./CreditNoteList.vue?vue&type=style&index=0&id=4dbd48ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports